<article
  class="national-qualifications-framework-descriptors-sub-domain-container"
>
  <div class="national-qualifications-framework-descriptors-sub-domain">
    <app-nqf-side-menu class="side-menu"></app-nqf-side-menu>

    <div class="sub-domain"><router-outlet></router-outlet></div>
  </div>
</article>
